<div class="pricing-layout">
  <header class="pricing-header">
    <div class="pricing-header__inner container">

      <a class="pricing-header__logo" (click)="goHome()" role="button" aria-label="Ir al inicio">
        <img src="assets/img/logo-tix-circle.svg" alt="TIX" height="54" />
      </a>

      <nav class="primary_nav d-md-block" [ngClass]="{ 'showNav': mobileMenuOpen }" id="primaryNavHeader">
        <ul class="nav d-flex fw-semibold">
          <li class="nav-item" *ngFor="let item of navItems">
            <a class="nav-link text-white" (click)="navigate(item)" style="cursor: pointer">
              {{ item.label }}
            </a>
          </li>
          <li class="nav-item d-block d-md-none">
            <a [href]="vendorsUrl" class="tix-btn tix-btn--outline" style="padding: 0.65rem 1.75rem; font-size: 0.95rem;">
              Mi cuenta
            </a>
          </li>
        </ul>
      </nav>

      <a [href]="vendorsUrl" class="pricing-header__account tix-btn tix-btn--outline">
        Mi cuenta
      </a>
      <button class="pricing-header__hamburger" (click)="toggleMobileMenu()" [attr.aria-expanded]="mobileMenuOpen"
        aria-label="Abrir menú">
        <span class="material-symbols-outlined">
          {{ mobileMenuOpen ? 'close' : 'segment' }}
        </span>
      </button>

    </div>

    <div class="pricing-header__backdrop" *ngIf="mobileMenuOpen" (click)="closeMobileMenu()"></div>
  </header>

  <section class="hero-banner">
    <div class="hero-banner__bg">
      <img src="assets/img/pricing-page-hero.webp" alt="Concierto en vivo" class="hero-banner__img" loading="lazy" />
      <div class="hero-banner__overlay"></div>
    </div>
    <div class="hero-banner__content container">
      <h1 class="hero-banner__title">
        Vende tickets sin<br />la complejidad
      </h1>
      <p class="hero-banner__subtitle">
        La plataforma de boletería digital que maneja todo desde ventas en línea
        hasta el check-in del evento. <br> Precios simples, funciones poderosas.
      </p>
    </div>
  </section>

  <section class="pricing-section features-section">
    <div class="container">

      <div class="grid-system">

        <!-- 1. Ventas en Línea -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#D0E3FD;">💳</div>
          <h4 class="feature-card__title">Ventas en Línea</h4>
          <p class="feature-card__description">
            Páginas de pago hermosas que convierten. Optimizadas para móvil y
            escritorio con correos de confirmación instantáneos.
          </p>
        </article>

        <!-- 2. Apple Pay y G Pay -->
        <article class="feature-card">
          <div class="feature-card__icon-row">
            <div class="icon-badge icon-badge--dark">
              <svg viewBox="0 0 24 24" fill="white" aria-hidden="true">
                <path
                  d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
              </svg>
            </div>
            <div class="icon-badge" style="background:#4285F4;">
              <svg viewBox="0 0 24 24" fill="white" aria-hidden="true">
                <path
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>
            </div>
          </div>
          <h4 class="feature-card__title">Apple Pay y G Pay</h4>
          <p class="feature-card__description">
            Pago con un toque para clientes móviles. Reduce la fricción y
            aumenta las tasas de conversión en un 40%.
          </p>
        </article>

        <!-- 3. Check-in APP -->
        <article class="feature-card">
          <div class="feature-card__icon-row">
            <div class="icon-badge icon-badge--full">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 800 800"
                enable-background="new 0 0 800 800" xml:space="preserve">
                <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="400.05" y1="798.7717" x2="400.05"
                  y2="-1.2283" gradientTransform="matrix(1 0 0 -1 0 798.7717)">
                  <stop offset="0" style="stop-color:#18BFFB" />
                  <stop offset="1" style="stop-color:#2072F3" />
                </linearGradient>
                <path fill="url(#SVGID_1_)" d="M638.4,0H161.6C72.3,0,0,72.3,0,161.6v476.9C0,727.7,72.3,800,161.6,800h476.9
	c89.2,0,161.6-72.3,161.6-161.6V161.6C800,72.3,727.7,0,638.4,0z" />
                <path fill="#FFFFFF" d="M396.6,183.8l16.2-28c10-17.5,32.3-23.4,49.8-13.4s23.4,32.3,13.4,49.8L319.9,462.4h112.9
	c36.6,0,57.1,43,41.2,72.8H143c-20.2,0-36.4-16.2-36.4-36.4c0-20.2,16.2-36.4,36.4-36.4h92.8l118.8-205.9l-37.1-64.4
	c-10-17.5-4.1-39.6,13.4-49.8c17.5-10,39.6-4.1,49.8,13.4L396.6,183.8L396.6,183.8z M256.2,572.7l-35,60.7
	c-10,17.5-32.3,23.4-49.8,13.4S148,614.5,158,597l26-45C213.4,542.9,237.3,549.9,256.2,572.7L256.2,572.7z M557.6,462.6h94.7
	c20.2,0,36.4,16.2,36.4,36.4c0,20.2-16.2,36.4-36.4,36.4h-52.6l35.5,61.6c10,17.5,4.1,39.6-13.4,49.8c-17.5,10-39.6,4.1-49.8-13.4
	c-59.8-103.7-104.7-181.3-134.5-233c-30.5-52.6-8.7-105.4,12.8-123.3C474.2,318.1,509.9,380,557.6,462.6L557.6,462.6z" />
              </svg>

            </div>
            <div class="icon-badge icon-badge--dark">
              <svg viewBox="0 0 28.99 31.99" xmlns="http://www.w3.org/2000/svg">
                <g data-name="Capa 2">
                  <g data-name="Capa 1">
                    <path d="M13.54 15.28.12 29.34a3.66 3.66 0 0 0 5.33 2.16l15.1-8.6Z" style="fill:#ea4335" />
                    <path
                      d="m27.11 12.89-6.53-3.74-7.35 6.45 7.38 7.28 6.48-3.7a3.54 3.54 0 0 0 1.5-4.79 3.62 3.62 0 0 0-1.5-1.5z"
                      style="fill:#fbbc04" />
                    <path d="M.12 2.66a3.57 3.57 0 0 0-.12.92v24.84a3.57 3.57 0 0 0 .12.92L14 15.64Z"
                      style="fill:#4285f4" />
                    <path d="m13.64 16 6.94-6.85L5.5.51A3.73 3.73 0 0 0 3.63 0 3.64 3.64 0 0 0 .12 2.65Z"
                      style="fill:#34a853" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <h4 class="feature-card__title">Check-in APP</h4>
          <p class="feature-card__description">
            Escanea tickets al instante con nuestra app móvil. Se sincroniza
            automáticamente, previene doble ingreso. Disponible para iPhone y Android.
          </p>
        </article>

        <!-- 4. Analíticas -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#C4F8D6;">📊</div>
          <h4 class="feature-card__title">Analíticas en Tiempo Real</h4>
          <p class="feature-card__description">
            Rastrea ventas, asistentes e ingresos mientras suceden. Exporta
            reportes detallados de ventas y la base de datos de tus participantes.
          </p>
        </article>

        <!-- 5. Pagos 24h -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#ECDBFE;">⏰</div>
          <h4 class="feature-card__title">Pagos en 24 horas</h4>
          <p class="feature-card__description">
            Recibe tus fondos en menos de 24 horas después del evento.
            Transferencias nacionales e internacionales.
          </p>
        </article>

        <!-- 6. Eventos Privados -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#EFE1FF;">🔒</div>
          <h4 class="feature-card__title">Eventos Privados</h4>
          <p class="feature-card__description">
            Crea eventos con acceso privado. Control total sobre quién puede
            comprar tickets.
          </p>
        </article>

      </div>

      <div class="seating-showcase">
        <picture>
          <!-- Versión Cuadrada (Mobile) -->
          <source media="(max-width: 768px)" srcset="assets/img/pricing-page-2dmap-square.webp">
          <!-- Versión Original/Rectangular (Desktop) -->
          <img src="assets/img/pricing-page-2dmap.png" alt="Mapa interactivo 3D y 2D para selección de asientos"
            class="seating-showcase__img" loading="lazy" />
        </picture>
      </div>

      <div class="grid-system">

        <!-- 7. Mapas 3D / 2D -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#fee6c7;">🏟️</div>
          <h4 class="feature-card__title">Mapas 3D / 2D</h4>
          <p class="feature-card__description">
            Experiencia inmersiva con mapas 3D del venue. Permite a los clientes
            ver exactamente su vista desde el asiento.
          </p>
        </article>

        <!-- 8. +250K Visitas -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#C8E0FE;">👁️</div>
          <h4 class="feature-card__title">+250K Visitas Mensuales</h4>
          <p class="feature-card__description">
            Nuestra plataforma recibe más de 250,000 visitas mensuales. Tu
            evento ganará exposición automáticamente al publicar.
          </p>
        </article>

        <!-- 9. Códigos de Descuentos -->
        <article class="feature-card">
          <div class="feature-card__icon"
            style="background:#E0D1F9; color:#5B21B6; font-weight:700; font-size:1.5rem; line-height:1;">%</div>
          <h4 class="feature-card__title">Códigos de Descuentos</h4>
          <p class="feature-card__description">
            Genera códigos promocionales personalizados. Define porcentaje y
            límites de uso.
          </p>
        </article>

        <!-- 10. Descuentos Bancos -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#CAE2FD;">🏦</div>
          <h4 class="feature-card__title">Descuentos Bancos</h4>
          <p class="feature-card__description">
            Aplica descuentos automáticos según el banco emisor o la marca de la
            tarjeta. Integración Bancos Dominicanos, Visa y Mastercard.
          </p>
        </article>

        <!-- 11. Wallets -->
        <article class="feature-card">
          <div class="feature-card__icon-row">
            <div class="icon-badge icon-badge--dark">
              <svg viewBox="0 0 24 24" fill="white" aria-hidden="true">
                <path
                  d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
              </svg>
            </div>
            <div class="icon-badge" style="background:#4285F4;">
              <svg viewBox="0 0 24 24" fill="white" aria-hidden="true">
                <path
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>
            </div>
          </div>
          <h4 class="feature-card__title">Apple Wallet y Google Wallet</h4>
          <p class="feature-card__description">
            Los tickets se agregan a las wallets digitales. Notificaciones push y
            actualizaciones en tiempo real.
          </p>
        </article>

        <!-- 12. Donación -->
        <article class="feature-card">
          <div class="feature-card__icon" style="background:#D1FADF;">🫶🏽</div>
          <h4 class="feature-card__title">Tickets Basado en Donación</h4>
          <p class="feature-card__description">
            Permite a los asistentes pagar lo que deseen. Perfecto para eventos
            benéficos o comunitarios.
          </p>
        </article>

      </div>

    </div>
  </section>

  <section class="pricing-section plans-section" id="precios">
    <div class="container">

      <div class="plans-section__header">
        <h2 class="section-headline">
          Precios simples<br />y transparentes
        </h2>
        <p class="section-subheadline">
          Sin mensualidades. Sin cargos ocultos. Solo una tarifa simple.
        </p>
      </div>

      <div class="plan-card">

        <div class="plan-card__price">
          <div class="plan-card__rate">4.9%</div>
          <div class="plan-card__base-fee">+ RD$25 por ticket</div>
          <p class="plan-card__buyer-note">
            Tus participantes pagan un cargo x servicio de 8.5% + RD$15 (Min RD$80)
          </p>
        </div>

        <hr class="divider-line" />

        <h3 class="plan-card__benefits-title">+ funcionalidades</h3>

        <div class="plan-card__benefits-grid">
          <div class="benefit-item" *ngFor="let f of [
            'Soporte 1A',
            'Protección contra fraude',
            'Entradas de Cortesía',
            'Programación de Early Birds',
            'Scan API',
            'Punto de venta',
            'Promoter Link',
            'Base de datos de participantes',
            'Avances de efectivo',
            'Impresión de tickets'
          ]">
            <span class="benefit-item__icon">
              <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                <path d="M2 6l3 3 5-5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span>{{ f }}</span>
          </div>
        </div>

        <div class="plan-card__action">
          <a [href]="vendorsUrl + '/auth/login'" target="_blank" rel="noopener noreferrer"
            class="tix-btn tix-btn--primary tix-btn--lg">
            Publicar evento
          </a>
        </div>

      </div>

      <div class="partners-showcase">
        <h2 class="partners-showcase__title">Algunos de nuestros amigos</h2>
        <div class="partners-showcase__logos">
          <picture>
            <source media="(max-width: 768px)" srcset="assets/img/pricing-page-friends-square.webp">
            <img src="assets/img/pricing-page-friends.png" alt="Marcas y organizadores que confían en TIX"
              class="partners-showcase__img" loading="lazy" />
          </picture>
        </div>
      </div>

    </div>
  </section>

  <section class="pricing-section conversion-section">
    <div class="container">
      <div class="conversion-section__content">
        <h2 class="conversion-section__title">
          Empieza a vender tickets<br />en minutos
        </h2>
        <p class="conversion-section__subtitle">
          Publica gratis y únete a cientos de organizadores de eventos que
          confían en nuestra plataforma.
        </p>
        <div class="conversion-section__buttons">
          <a [href]="vendorsUrl + '/auth/login'" target="_blank" rel="noopener noreferrer"
            class="tix-btn tix-btn--primary tix-btn--lg">
            Crea tu primer evento
          </a>
          <a [href]="whatsappUrl" target="_blank" rel="noopener noreferrer" class="tix-btn tix-btn--dark tix-btn--lg">
            Hablar con ventas
          </a>
        </div>
      </div>
    </div>
  </section>

</div>